import { APPROVAL_STEP_CLASS_MAP, STATUS_MAP } from '../constants'

export var getApprovalStepClass = function (status) {
  var statusObj = STATUS_MAP[status]
  var statusKey = statusObj && statusObj.key ? statusObj.key : 'default'
  return APPROVAL_STEP_CLASS_MAP[statusKey]
}

export var getApprovalStepMeta = function (status) {
  var cfg = STATUS_MAP[status] || STATUS_MAP[5]

  return {
    label: cfg.label,
    color: cfg.color,
    className: getApprovalStepClass(status),
  }
}
